/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-18 15:48:24
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:21:38
 */
import personalCenter from './personal-center';
const fileUpload = () => import(/* webpackChunkName: "system" */'../views/system-control/index.vue');
const editReport = () => import(/* webpackChunkName: "personal" */'../views/edit-report/index.vue');
const register = () => import(/* webpackChunkName: "personal" */'../views/register/index.vue');

export const global = [
  {
    path: '/personal',
    name: 'personal',
    component: () => import(/* webpackChunkName: "personal" */ '../layout-personal/main.vue'),
    redirect: '/personal-turn',
    children: [
      ...personalCenter,
      {
        path: '/personal-turn',
        name: 'personal-turn',
        meta: {
          name: '个人中心',
        },
        component: () => import(/* webpackChunkName: "personal" */ '../views/personal-center/index.vue'),
      }
    ],
  },
  {
    path: '/edit-report',
    name: 'edit-report',
    meta: {
      name: '编辑报表',
      parentsName: 'shop-management',
      keepAlive: false
    },
    component: editReport,
  },
  {
    path: '/pearlgo-login',
    name: 'pearlgo-login',
    meta: {
      name: '登录',
      parentsName: 'shop-management',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "personal" */ '../views/login/bi-login.vue'),
  },
  {
    path: '/zhizh-login',
    name: 'zhizh-login',
    meta: {
      name: '登录',
      parentsName: 'shop-management',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "personal" */ '../views/login/bi-login.vue'),
  },
  {
    path: '/gule-login',
    name: 'gule-login',
    meta: {
      name: '登录',
      parentsName: 'shop-management',
      keepAlive: false
    },
    component: () => import(/* webpackChunkName: "personal" */'../views/login/bi-login.vue'),
  },
  {
    path: '/system-control',
    name: 'system-control',
    meta: {
      name: '系统控制',
      keepAlive: true
    },
    component: fileUpload,
  },
  {
    path: '/register',
    name: 'site-create',
    meta: {
      name: '注册',
      keepAlive: false
    },
    component: register,
  },
]
